import Vue from 'vue';
import snotify, { SnotifyPosition } from 'vue-snotify';
import 'vue-snotify/styles/material.css';

Vue.use(snotify, {
    toast: {
        position: SnotifyPosition.rightTop,
    },
});
